import React from 'react'
import { useAtSize, SocialBar, HeaderBlock, SocialMenu, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import type { Person } from '../../types/persons'

const mediaBannerCss = css`
  text-align: center;
`

const headerCss = css`
  display: block;
  margin-bottom: 14px;

  & h5 {
    font-weight: none;
  }
`

const apps = ['facebook', 'twitter', 'whatsApp']

type ShareButtonProps = {
  name: string
  product: string
  analytics: Record<string, unknown>
}

export function ShareButton({ name, product, analytics }: ShareButtonProps): JSX.Element {
  const [t] = useTranslation()

  const sharable = {
    url: window.location.href,
    subject: t('person-page-banner.share-subject', { name }),
  }

  return (
    <SocialMenu
      sharable={sharable}
      apps={apps}
      product={product}
      analytics={analytics}
      inline={false}
      buttonEmphasis="low"
    />
  )
}

export default function AncestorSocial({
  person,
  analytics,
}: {
  person: Person
  analytics: Record<string, string>
}): JSX.Element {
  const [t] = useTranslation()
  const atSize = useAtSize()

  const isMobile = atSize({ lg: false, default: true })
  const { name } = person
  const sharable = {
    url: window.location.href,
    subject: t('ancestors.social-media-banner.share-subject', {
      name,
    }),
  }
  const product =
    `${analytics.link_app ? `${analytics.link_app} ` : ''}${analytics.link_page || ''}`.replace(/: /g, '_') ||
    'Person_Footer' // Must not have colons or spaces

  return (
    <div css={mediaBannerCss}>
      <div css={headerCss}>
        <HeaderBlock centered size="sm" heading={t('ancestors.social-media-banner.header')} />
      </div>
      {!isMobile && (
        <Row alignX="center">
          <SocialBar sharable={sharable} apps={apps} product={product} analytics={analytics} />
        </Row>
      )}
      {isMobile && (
        <ShareButton name={name} product={product} analytics={analytics} data-testid="social-media-share-button" />
      )}
    </div>
  )
}
